import { useMemo } from "react";
import { AioIconButton } from "../additional/aioIconButton";
import {
  AitLocationBodyRow,
  AitLocationHeaderRow,
  AitTablePosition,
  REMOVE_ROW,
} from "./functions/interface";
import { useTableContext } from "./TableContextProvider";

interface AitRemoveRowButtonProps {
  location: AitLocationHeaderRow | AitLocationBodyRow;
}

/**
 * Button to remove a row when permitted by the row group state.
 *
 * @param props - Component props
 * @param props.location - The row location
 */
export const AitRemoveRowButton = ({ location }: AitRemoveRowButtonProps) => {
  const { state, dispatch } = useTableContext();
  const thisRowGroup =
    location.position === AitTablePosition.headerRow
      ? state?.originalTableData.headerData
      : state?.originalTableData.bodyData.find((group) => group.aitid === location.rowGroupId);

  const canRemoveRow = useMemo(() => {
    return state?.editable && thisRowGroup ? thisRowGroup.rows.length > 1 : false;
  }, [state?.editable, thisRowGroup]);

  return !state || !thisRowGroup || !canRemoveRow ? null : (
    <AioIconButton
      id={`${state.id}-remove-row`}
      tipText="Remove row"
      iconName={"aioxMinus"}
      aria-label="Remove row"
      onClick={() => {
        dispatch({
          operation: REMOVE_ROW,
          location,
          newLength: thisRowGroup.rows.length - 1,
        });
      }}
    />
  );
};

AitRemoveRowButton.displayName = "AitRemoveRowButton";
